<template>
  <div class="sa-card sa-patient-details">
    <h6>Patient Details</h6>
    <div class="sa-pat-bord" v-for="(item, index) in patientData" :key="index">
      <div class="sa-user-self sa-cursor" @click="toggleCard(index)">
        <div class="sa-d-flex">
          <figure class="sa-avt-img">
            <img :src="item.image || imgUrl" alt="Doctor" class="sa-img-cover" />
          </figure>
          <div>
            <h6>{{ item.name }}</h6>
            <span class="sa-gray-text">{{ item.relation }}</span>
          </div>
        </div>
        <span>
          <span class="sa-red-text sa-mr5" v-if="!item.pat_available || isActive">Unavailable</span>
          <i :class="activeIndex === index ? 'icon-up-arrow ' : 'icon-down-arrow '" class="sa-gray-text"></i>
        </span>
      </div>
      <div v-if="activeIndex === index">
        <!-- todo vital sign -->
        <!-- <button class="sa-btn sa-btn-primary sa-mt10"><i class="icon-heart sa-mr5"></i>Add vital sign</button>
        <PatientProgress /> -->
        <SelectedTests v-for="(tests, t) in item.services" :key="t" :tests="tests"/>
        <div class="sa-pat-switch" v-if="!sampleStatus">
          <span class="sa-gray-text">Patient not available, unable to collect sample</span>
          <div class="sa-switch">
            <input type="checkbox" id="notific" name="notific" :checked="isActive" @change="toggleSwitch"/>
            <label for="notific">
              <span class="sa-input-box"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PatientProgress from "./PatientProgress.vue";
import SelectedTests from "./SelectedTests.vue";
export default {
  props: ['patientData','sampleStatus'],
  components: { PatientProgress, SelectedTests },
  data() {
    return {
      isActive:false,
      imgUrl: 'https://img.litedev.com/images/unknown-avtar.png',
      activeIndex: null
    };
  },
  methods: {
    toggleSwitch(){
      this.isActive = !this.isActive
      this.$emit('toggle-status',this.isActive)
    },
    toggleCard(index){
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    }
  },
};
</script>
